import { render, staticRenderFns } from "./NtaxCode.vue?vue&type=template&id=72e8a670&"
import script from "./NtaxCode.vue?vue&type=script&lang=js&"
export * from "./NtaxCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports